import { QuickReply } from '../types';
import { mockQuickReplies } from '../data/mockData';

// In-memory store for simulation. In a real app, this would be a database.
let replies: QuickReply[] = [...mockQuickReplies];

export const getQuickRepliesApi = async (): Promise<QuickReply[]> => {
  // console.log('API Call: GET /api/quick-replies');
  return Promise.resolve(replies);
};

export const createQuickReplyApi = async (reply: Omit<QuickReply, 'id'>): Promise<QuickReply> => {
  // console.log('API Call: POST /api/quick-replies', reply);
  const newReply: QuickReply = { ...reply, id: `qr_${Date.now()}` };
  replies.push(newReply);
  return Promise.resolve(newReply);
};

export const updateQuickReplyApi = async (reply: QuickReply): Promise<QuickReply> => {
  // console.log('API Call: PUT /api/quick-replies/:id', reply);
  replies = replies.map(r => r.id === reply.id ? reply : r);
  return Promise.resolve(reply);
};

export const deleteQuickReplyApi = async (id: string): Promise<{ success: boolean }> => {
  // console.log('API Call: DELETE /api/quick-replies/:id', { id });
  replies = replies.filter(r => r.id !== id);
  return Promise.resolve({ success: true });
};
